var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSort = function SvgSort(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "#93A1BD",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00047 2.37254L5.84547 4.21754C6.13797 4.51004 6.61047 4.51004 6.90297 4.21754C7.19547 3.92504 7.19547 3.45254 6.90297 3.16004L4.52547 0.775039C4.23297 0.482539 3.76047 0.482539 3.46797 0.775039L1.09047 3.16004C0.797969 3.45254 0.797969 3.92504 1.09047 4.21754C1.38297 4.51004 1.85547 4.51004 2.14797 4.21754L4.00047 2.37254ZM4.00047 11.6275L2.15547 9.78254C1.86297 9.49004 1.39047 9.49004 1.09797 9.78254C0.805469 10.075 0.805469 10.5475 1.09797 10.84L3.47547 13.225C3.76797 13.5175 4.24047 13.5175 4.53297 13.225L6.91047 10.8475C7.20297 10.555 7.20297 10.0825 6.91047 9.79004C6.61797 9.49754 6.14547 9.49754 5.85297 9.79004L4.00047 11.6275Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSort, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sort.f1c9ae06.svg";
export { ForwardRef as ReactComponent };